<script>
import { h } from "vue";

// Ícones de linha (24×24) usados em várias telas. Só o desenho fica aqui:
// tamanho, espessura e classes vêm de quem usa, como atributos normais do
// <svg> (ex.: <AppIcon name="busca" width="16" height="16" stroke-width="2" />).
const ICONES = {
  carregando: [
    [
      "path",
      {
        d: "M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4",
      },
    ],
  ],
  mais: [["path", { d: "M12 5v14M5 12h14" }]],
  busca: [
    ["circle", { cx: "11", cy: "11", r: "8" }],
    ["path", { d: "M21 21l-4.35-4.35" }],
  ],
  fechar: [["path", { d: "M18 6L6 18M6 6l12 12" }]],
  prancheta: [
    [
      "path",
      {
        d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z",
      },
    ],
  ],
  check: [["path", { d: "M20 6L9 17l-5-5" }]],
  alerta: [
    ["circle", { cx: "12", cy: "12", r: "10" }],
    ["path", { d: "M12 8v4M12 16h.01" }],
  ],
  voltar: [["path", { d: "M19 12H5M12 5l-7 7 7 7" }]],
  editar: [
    [
      "path",
      {
        d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125",
      },
    ],
  ],
};

export default {
  name: "AppIcon",
  props: {
    name: { type: String, required: true },
  },
  render() {
    return h(
      "svg",
      { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor" },
      (ICONES[this.name] || []).map(([tag, attrs]) => h(tag, attrs))
    );
  },
};
</script>
